import React from 'react';
import { Card, Box, Avatar, Typography } from '@mui/material';

const formatDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
};

export default function UserProfileSidebar({ user }) {
  if (!user) return null;

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <Avatar src={user.avatar || undefined} alt={user.display_name || user.username} sx={{ width: 64, height: 64 }}>
          {!user.avatar && (user.display_name || user.username)?.[0]}
        </Avatar>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {user.display_name || user.username}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {user.posts_count} posts | {user.comments_count} comments
        </Typography>
        {user.date_joined && (
          <Typography variant="caption" color="text.secondary">
            Joined in {formatDate(user.date_joined)}
          </Typography>
        )}
      </Box>
    </Card>
  );
}
